const CARET_WIDTH = 10;
const CARET_HEIGHT = 6;
const CARET_RIGHT_OFFSET = 10;

// Right padding reserves space for the caret: its width + offset + visual gap.
export const CARET_RIGHT_PADDING = CARET_WIDTH + CARET_RIGHT_OFFSET + 12;
export function buildNativeSelectCaretStyles(textSecondaryColor) {
  const caretColor = encodeURIComponent(textSecondaryColor);
  const caretUrl = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='${caretColor}' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E")`;
  return {
    appearance: 'none',
    WebkitAppearance: 'none',
    backgroundImage: caretUrl,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: `right ${CARET_RIGHT_OFFSET}px center`,
    backgroundSize: `${CARET_WIDTH}px ${CARET_HEIGHT}px`
  };
}